import type { FetchRequestArgs } from '../../utils';
import { fetchRequest } from '../../utils';
import { HTTPMethod } from '../httpMethods';

// Creates a new Workflow for a given location and board
export const createWorkflow = async <T extends Record<string, unknown>>({
  data,
  domain,
  headers,
  query,
  locationId,
  boardId,
  signal,
}: FetchRequestArgs & { locationId: string; boardId: string }): Promise<
  ReturnType<typeof fetchRequest>
> =>
  fetchRequest<T>({
    data,
    domain,
    endpoint: `/v2/locations/${locationId}/boards/${boardId}/workflows`,
    headers,
    method: HTTPMethod.POST,
    query,
    signal,
  });
